<template>
  <div>
    <!-- Bloque inicial -->
    <v-container fluid class="py-0">
      <v-row class="px-0">
        <v-col class="px-0 py-0">
          <template v-if="servicio.cover.mime == 'video/mp4'">
            <div style="height: calc((100vh - 110px) / 2); position: relative">
              <video
                :src="
                  'https://nncms.actstudio.xyz/storage/uploads/' +
                  servicio.cover.path
                "
                :autoplay="true"
                    :muted="true"
                    :playsinline="true"
                    :controls="false"
                    :loop="true"
                style="
                  position: absolute;
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                  z-index: 0;
                "
              ></video>
              <div
                style="
                  background: rgb(90, 35, 178);
                  background: linear-gradient(
                    0deg,
                    rgba(90, 35, 178, 0.3) 12%,
                    rgba(90, 35, 178, 0.3) 52%,
                    rgba(90, 35, 178, 0.5) 100%
                  );
                  position: relative;
                "
              >
                <v-container class="py-0">
                  <v-row
                    align="center"
                    style="
                      position: relative;
                      height: calc((100vh - 110px) / 2);
                    "
                  >
                    <v-col class="text-center">
                      <span
                        class="d-block titulos-size color-blanco bold mb-5"
                        style="font-size: 55px"
                        >{{ servicio.name }}</span
                      >
                      <span
                        class="color-blanco bold enfasis-size d-none d-md-block"
                        style="white-space: pre"
                        >{{ servicio.subtitle }}</span
                      >
                      <span
                        class="color-blanco bold enfasis-size d-md-none d-block"
                        >{{ servicio.subtitle }}</span
                      >
                    </v-col>
                  </v-row>
                </v-container>
              </div>
            </div>
          </template>
          <template v-else>
            <v-img
              :src="
                'https://nncms.actstudio.xyz/storage/uploads' +
                servicio.cover.path
              "
              class="text-center align-center"
              style="height: calc((100vh - 110px) / 2)"
            >
              <div
                style="
                  background: rgb(90, 35, 178);
                  background: linear-gradient(
                    0deg,
                    rgba(90, 35, 178, 0.3) 12%,
                    rgba(90, 35, 178, 0.3) 52%,
                    rgba(90, 35, 178, 0.5) 100%
                  );
                  position: relative;
                  height: calc((100vh - 110px) / 2);
                "
                class="d-flex align-center justify-center"
              >
                <v-container>
                  <v-row>
                    <v-col>
                      <span
                        class="d-block titulos-size color-blanco bold mb-5"
                        style="font-size: 55px"
                        >{{ servicio.name }}</span
                      >
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <span
                        class="color-blanco bold enfasis-size d-none d-md-block"
                        style="white-space: pre"
                        >{{ servicio.subtitle }}</span
                      >
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <span
                        class="color-blanco bold enfasis-size d-md-none d-block"
                        >{{ servicio.subtitle }}</span
                      >
                    </v-col>
                  </v-row>
                </v-container>
              </div>
            </v-img>
          </template>
        </v-col>
      </v-row>
    </v-container>
    <!-- Termina bloque inicial -->

    <!-- Inicia bloque de descripción del servicio -->
    <div class="color-blanco" style="background-color: #5c27b2">
      <v-container class="py-0">
        <v-row
          align="center"
          justify="center"
          style="min-height: calc((100vh - 110px) / 2)"
        >
          <template v-if="!iconoEnDescripcionGeneral">
            <!-- No hay imagen -->
            <v-col cols="10" md="8" class="text-center py-5">
              <span class="d-block titulos-size bold">{{
                servicio.subtituloDescripcionGeneral
              }}</span>
              <p class="d-block">{{ servicio.descripcionGeneral }}</p>
            </v-col>
          </template>
          <template v-else>
            <!-- Hay imagen -->

            <v-col cols="10" md="8" class="text-center py-5">
              <v-img
                :src="
                  'https://nncms.actstudio.xyz/' +
                  servicio.iconoDescripcionGeneral.path
                "
                width="40px"
                class="mx-auto"
              ></v-img>
              <span class="d-block titulos-size bold my-6">{{
                servicio.subtituloDescripcionGeneral
              }}</span>
              <p class="d-block">{{ servicio.descripcionGeneral }}</p>
            </v-col>
          </template>
        </v-row>
      </v-container>
    </div>
    <!-- Termina bloque de descripción del servicio -->

    <template v-if="servicio.activarSeccionCaracteristicas">
      <v-container class="my-10">
        <v-row justify="center">
          <v-col class="text-center" cols="auto">
            <p
              class="montserrat single-item-size color-morado-2"
              style="max-width: 415px"
            >
              {{ servicio.textoCaracteristicas }}
            </p>
          </v-col>
        </v-row>

        <v-row justify="center" class="my-10">
          <v-col
            cols="12"
            md="4"
            class="px-10 text-center"
            style="border-right: 1px solid #5c27b2"
          >
            <v-img
              :src="
                'https://nncms.actstudio.xyz/' +
                servicio.imagenCaracteristica.path
              "
              width="90px"
              class="mb-4 mx-auto"
            ></v-img>

            <p
              class="montserrat bold titulos-size color-morado-2"
              style="white-space: break-spaces"
            >
              {{ servicio.textoCaracteristica }}
            </p>
          </v-col>
          <v-col cols="12" md="4" class="px-10 text-center">
            <v-img
              :src="
                'https://nncms.actstudio.xyz/' +
                servicio.imagenCaracteristica2.path
              "
              width="90px"
              class="mb-4 mx-auto"
            ></v-img>

            <p
              class="montserrat bold titulos-size color-morado-2"
              style="white-space: break-spaces"
            >
              {{ servicio.textoCaracteristica2 }}
            </p>
          </v-col>
          <v-col
            cols="12"
            md="4"
            class="px-10 text-center"
            style="border-left: 1px solid #5c27b2"
          >
            <v-img
              :src="
                'https://nncms.actstudio.xyz/' +
                servicio.imagenCaracteristica3.path
              "
              width="90px"
              class="mb-4 mx-auto"
            ></v-img>

            <p
              class="montserrat bold titulos-size color-morado-2"
              style="white-space: break-spaces"
            >
              {{ servicio.textoCaracteristica3 }}
            </p>
          </v-col>
        </v-row>
      </v-container>
    </template>

    <template v-if="servicio.texto1Activo">
      <v-container
        fluid
        style="background-color: #2a0d56"
        class="py-12 py-sm-0"
      >
        <v-row align="center" justify="center">
          <v-col cols="10" sm="6" class="px-0 py-0">
            <v-img
              :src="
                'https://nncms.actstudio.xyz/' +
                servicio.imagenBloquePromocion.path
              "
            >
              <div style="width: 100%; height: 100%"></div>
            </v-img>
          </v-col>
          <v-col cols="10" sm="6">
            <v-row class="color-blanco" justify="center">
              <v-col cols="auto">
                <div style="max-width: 400px">
                  <span class="d-block bold titulos-size">{{
                    servicio.bloquePromocionTitulo
                  }}</span>
                  <p
                    class="d-block mt-3"
                    v-html="servicio.bloquePromocionDescripcion"
                  ></p>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </template>

    <template v-if="servicio.texto2Activo">
      <v-container
        fluid
        style="background-color: #2a0d56"
        class="py-12 py-sm-0"
      >
        <v-row align="center" justify="center">
          <v-col cols="10" sm="6">
            <v-row class="color-blanco" justify="center">
              <v-col cols="auto">
                <div style="max-width: 400px">
                  <span class="d-block bold titulos-size">{{
                    servicio.bloquePromocionTitulo2
                  }}</span>
                  <p
                    class="d-block mt-3"
                    v-html="servicio.bloquePromocionDescripcion2"
                  ></p>
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="10" sm="6" class="px-0 py-0">
            <v-img
              :src="
                'https://nncms.actstudio.xyz/' +
                servicio.imagenBloquePromocion2.path
              "
            >
              <div style="width: 100%; height: 100%"></div>
            </v-img>
          </v-col>
        </v-row>
      </v-container>
    </template>

    <template v-if="servicio.texto3Activo">
      <v-container
        fluid
        style="background-color: #2a0d56"
        class="py-12 py-sm-0"
      >
        <v-row align="center" justify="center">
          <v-col cols="10" sm="6" class="px-0 py-0">
            <v-img
              :src="
                'https://nncms.actstudio.xyz/' +
                servicio.imagenBloquePromocion3.path
              "
            >
              <div style="width: 100%; height: 100%"></div>
            </v-img>
          </v-col>
          <v-col cols="10" sm="6">
            <v-row class="color-blanco" justify="center">
              <v-col cols="auto">
                <div style="max-width: 400px">
                  <span class="d-block bold titulos-size">{{
                    servicio.bloquePromocionTitulo3
                  }}</span>
                  <p
                    class="d-block mt-3"
                    v-html="servicio.bloquePromocionDescripcion3"
                  ></p>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </template>

    <template v-if="servicio.texto4Activo">
      <v-container
        fluid
        style="background-color: #2a0d56"
        class="py-12 py-sm-0"
      >
        <v-row align="center" justify="center">
          <v-col cols="10" sm="6">
            <v-row class="color-blanco" justify="center">
              <v-col cols="auto">
                <div style="max-width: 400px">
                  <span class="d-block bold titulos-size">{{
                    servicio.bloquePromocionTitulo4
                  }}</span>
                  <p
                    class="d-block mt-3"
                    v-html="servicio.bloquePromocionDescripcion4"
                  ></p>
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="10" sm="6" class="px-0 py-0">
            <v-img
              :src="
                'https://nncms.actstudio.xyz/' +
                servicio.imagenBloquePromocion4.path
              "
            >
              <div style="width: 100%; height: 100%"></div>
            </v-img>
          </v-col>
        </v-row>
      </v-container>
    </template>

    <!-- Inicia Mapa -->
    <template v-if="servicio.activarMapa">
      <v-container fluid>
        <v-row justify="center" style="background-color: #deebfa">
          <v-col
            class="px-0 py-0 home-columna-mapa"
            style="background-color: #deebfa"
          >
            <MapaServicio v-bind:mapSelected="servicio.mapa"></MapaServicio>
          </v-col>

          <v-col cols="auto" class="px-0 py-0">
            <v-card
              color="#5C27B2"
              height="100%"
              tile
              class="align-self-center"
              elevation="0"
            >
              <v-row align="center" style="height: 100%">
                <v-col>
                  <div class="text-center color-blanco" style="width: 433px">
                    <div class="mx-auto" style="max-width: 336px">
                      <span class="bold" style="font-size: 20px"
                        >Cobertura Neutral Networks</span
                      >

                      <p class="my-6">
                        Nuestra red de activos abarca 7 de las 9 regiones de
                        telecomuncaciones en México, brindando conectividad a
                        las principales plazas del país
                      </p>

                      <span class="bold mb-3 d-block" style="font-size: 20px"
                        >Conectando a México hacia una nueva era</span
                      >

                      <v-row align="center" justify="center">
                        <v-col cols="auto">
                          <v-img
                            src="../assets/img/fibra-icono.png"
                            width="43"
                            class="d-inline-block mr-4"
                          ></v-img>
                        </v-col>
                        <v-col cols="auto" class="text-left">
                          <span class="d-inline-block" style="max-width: 160px"
                            >+ 2,500 kms de fibra Óptica</span
                          >
                        </v-col>
                      </v-row>

                      <v-row align="center" justify="center">
                        <v-col cols="auto">
                          <v-img
                            src="../assets/img/icono-larga-distancia.png"
                            width="43"
                            class="d-inline-block mr-4"
                          ></v-img>
                        </v-col>
                        <v-col cols="auto" class="text-left">
                          <span class="d-inline-block" style="max-width: 160px"
                            >+ 1,300 kms de larga distancia</span
                          >
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </template>
    <!-- Termina Mapa -->

    <v-container class="py-12">
      <v-row class="mb-6">
        <v-col cols="12" class="text-center">
          <span
            class="montserrat bold titulos-size color-morado d-none d-md-inline"
            style="white-space: pre"
            >{{ servicio.tituloVentajas }}</span
          >
          <span class="montserrat bold titulos-size color-morado d-md-none">{{
            servicio.tituloVentajas
          }}</span>
        </v-col>
      </v-row>
      <v-row>
        <template v-for="(ventaja, v) in servicio.ventajas">
          <template v-if="v % 2 == 0">
            <v-col
              :key="'ventaja-' + v"
              cols="12"
              md="4"
              offset="0"
              offset-md="1"
              class="text-center"
            >
              <v-img
                block
                :src="'https://nncms.actstudio.xyz/' + ventaja.value.Icono.path"
                width="90px"
                class="mx-auto"
              ></v-img>
              <span
                class="color-morado-2 bold enfasis-size my-6 d-block text-center"
                >{{ ventaja.value.Titulo }}</span
              >
              <p class="color-morado mx-auto" style="max-width: 372px">
                {{ ventaja.value.Descripcion }}
              </p>
            </v-col>
          </template>
          <template v-else>
            <v-col
              :key="'ventaja-' + v"
              cols="12"
              md="4"
              offset="0"
              offset-md="2"
              class="text-center"
            >
              <v-img
                block
                :src="'https://nncms.actstudio.xyz/' + ventaja.value.Icono.path"
                width="90px"
                class="mx-auto"
              ></v-img>
              <span
                class="color-morado-2 bold enfasis-size my-6 d-block text-center"
                >{{ ventaja.value.Titulo }}</span
              >
              <p class="color-morado mx-auto" style="max-width: 372px">
                {{ ventaja.value.Descripcion }}
              </p>
            </v-col>
          </template>
        </template>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      servicio: {
        cover: {
          path: "",
        },
        iconoDescripcionGeneral: {
          path: "",
        },
      },
    };
  },
  mounted: function () {
    fetch(
      "http://nncms.actstudio.xyz/api/collections/get/Servicios?token=8cf7ca41761951fdde0c1e2cfda401",
      {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          filter: {
            url: this.$route.params.url,
            destacado: true,
          },
          populate: 1, // resolve linked collection items
        }),
      }
    )
      .then((res) => res.json())
      .then((res) => (this.servicio = res.entries[0]));
  },
  computed: {
    iconoEnDescripcionGeneral: function () {
      var a = true;
      if (this.servicio.iconoDescripcionGeneral == undefined) {
        a = false;
      }

      return a;
    },
  },
  watch: {
    $route() {
      fetch(
        "http://nncms.actstudio.xyz/api/collections/get/Servicios?token=8cf7ca41761951fdde0c1e2cfda401",
        {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            filter: {
              url: this.$route.params.url,
              destacado: true,
            },
            populate: 1, // resolve linked collection items
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => (this.servicio = res.entries[0]));
    },
  },
  components: {
    MapaServicio: () => import("../components/MapaServicio.vue"),
  },
};
</script>